export default {
  create: {
    title: 'Add',
    subtitle: 'Word search',
  },
  edit: {
    title: 'Edit',
    subtitle: 'Game',
    button: {
      add: 'New game',
    },
  },
  list: {
    title: 'Word search',
    subtitle: 'List',
    add: 'New game',
  },
  card: {
    title: 'Word search generator',
    actions: 'Actions',
    defaultSettings: 'Default settings',
  },
  table: {
    title: 'Active games',
    searchPlaceholder: 'Search...',
    groupedTooltip: 'This group contains multiple word searches.',
  },
  form: {
    name: {
      label: 'Name:',
      invalid: 'Name is required',
    },
    enableGroupedGeneration: {
      label: 'Generate multiple games at once',
      tooltip:
        'Allows you to create several word search games at the same time.',
    },
    rows: {
      label: 'Row size:',
      placeholder: 'Number of rows',
    },
    columns: {
      label: 'Column size:',
      placeholder: 'Number of columns',
    },
    positions: {
      label: 'Word placement',
      horizontal: 'Horizontal',
      vertical: 'Vertical',
      diagonal: 'Diagonal',
      inverted: 'Reversed',
      invertedHorizontal: 'Reversed horizontal',
      invertedVertical: 'Reversed vertical',
      invertedDiagonal: 'Reversed diagonal',
    },
    enableSubWord: {
      label: 'Avoid words contained in other words',
    },
    showGrid: {
      label: 'Show grid',
    },
    showWordPositions: {
      label: 'Highlight words',
    },
    highlightMode: {
      color: 'Background color',
      border: 'Soft border',
    },
    wordsList: {
      label: 'Word list (one per line)',
    },
    totalWords: {
      label: 'Total words:',
    },
    game: 'Game {n}',
  },
  button: {
    generateAgain: 'Generate again',
    openAll: 'Open all',
    closeAll: 'Close all',
  },
  sidebar: {
    exportHint: 'You need to save before exporting.',
    sendHint: 'You need to save before sending.',
    sendToSite: 'Send to site',
    defaultFileName: 'word-search',
  },
  sendModal: {
    description: 'Select the games you want to send to the site:',
    selectAll: 'Select all',
    noChildren: 'No child games available to send.',
  },
  popover: {
    title: 'Placed words',
    description: 'were used in the word search',
  },
  alert: {
    wordsTooBig: {
      intro:
        'The following words are larger than the available space in <strong>game {gameNumber}</strong>:',
    },
    sendSuccess: 'Sent successfully',
    sendError: 'Error sending. Please try again.',
  },
};
